import React from 'react';

import QuestionHOC from './QuestionHOC';

export default function Diagnosis({ item, index }) {
  return <QuestionHOC item={item} index={index}>
    <div className="row">
      <div className="col">
        <p className="mt-3" style={{ fontSize: 18, fontWeight: 'bold' }}>Diagnosis</p>
        <p>Possible L5-S1 discogenic or facet mediated back pain</p>
      </div>
    </div>
  </QuestionHOC>
}